import type { FC } from 'react'

import type { FanResponseProjection } from '@api'

import EyeIcon from '@/assets/icons/icon-eye.svg'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Skeleton } from '@/components/ui/skeleton'
import { IconButton } from '@/modules/chatting/ui/components/icon-button'

type NoSpendersFanItemProps = {
  isLoading: boolean
} & (
  | {
      fan: FanResponseProjection
      onView: () => void
      isLoading?: false
    }
  | {
      isLoading: true
    }
)

export const NoSpendersFanItem: FC<NoSpendersFanItemProps> = (
  props: NoSpendersFanItemProps,
) => {
  const handleView = () => {
    if (props.isLoading === false) {
      window.open(`https://onlyfans.com/${props.fan.username}`, '_blank')
    }
  }

  return (
    <div className="border-b-border flex w-full items-center gap-2 border-b py-3">
      <Avatar>
        {props.isLoading ? (
          <Skeleton className="h-12 w-12 dark:!bg-slate-500" />
        ) : props.fan.avatar ? (
          <AvatarImage src={props.fan.avatar} />
        ) : (
          <AvatarFallback className="bg-secondary-50 dark:bg-secondary-300 dark:text-white">
            {props.fan.fanName?.slice(0, 2).toUpperCase()}
          </AvatarFallback>
        )}
      </Avatar>
      <div className="flex w-full items-center justify-between">
        <span className="text-sm font-medium text-black  dark:text-white">
          {props.isLoading ? (
            <Skeleton className="h-4 w-44 dark:!bg-slate-500" />
          ) : (
            props.fan.fanName
          )}
        </span>
        <IconButton
          onClick={handleView}
          icon={EyeIcon}
          iconClassName="w-5 h-5 text-primary-500"
          testId="view-fan-button"
        />
      </div>
    </div>
  )
}
